export const YouTube = () => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.24898 14.3938C2.24898 12.6831 2.97158 10.3756 3.59879 9.09405C7.83467 0.456725 19.0249 -1.18318 25.5138 5.27097C32.3207 12.0401 30.1529 23.0846 22.1971 27.1663C19.4642 28.5678 17.73 28.6212 14.8107 28.6212C11.6153 28.6212 8.28702 26.6331 6.14957 24.502C5.03821 23.3937 4.30261 22.3737 3.49763 20.715C2.48165 18.6214 2.24898 16.6405 2.24898 14.3967V14.3938ZM13.7773 0.167755C11.2092 0.709575 10.2641 0.936416 8.20175 2.1342C5.12637 3.92148 2.61895 7.15795 1.62176 10.536C0.38756 14.716 0.813894 18.919 3.00626 22.6453C8.19742 31.4676 20.7605 32.6885 27.527 24.4774C34.1243 16.47 30.822 4.21768 20.4888 0.70235C18.863 0.148972 15.7009 -0.236803 13.7788 0.167755H13.7773Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3814 16.6247C14.2196 15.976 14.3337 15.005 14.3294 14.2609C14.3236 13.3623 14.0895 12.6745 14.9248 13.0689C15.8584 13.5111 17.2559 14.4257 18.1707 14.7262C17.9251 15.2348 18.3557 14.8042 17.7112 15.1972C17.5681 15.2839 17.4048 15.3403 17.2675 15.4082C16.4163 15.8373 14.8497 16.9007 14.3814 16.6233V16.6247ZM9.24086 14.0009C9.24086 16.2809 8.86366 19.0362 10.8797 19.513C12.3235 19.8554 18.9931 19.7528 20.629 19.5563C22.3127 19.3541 22.6118 17.8846 22.6118 16.3661C22.6118 10.4061 23.1567 10.2096 15.87 10.3021C14.2196 10.3223 12.442 10.2399 10.8812 10.487C9.4085 10.7211 9.24086 12.3812 9.24086 14.0009Z"
      fill="currentColor"
    />
  </svg>
)
